import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";

import UserEditorModal from "./user-editor-modal.jsx";

import UserActions from "../../actions/UserActions";
import GodActions from "../../actions/GodActions";

const NEW_USER = "NEW";

class UserTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deletedUsers: {},
      userIdBeingEdited: null
    };

    this._edit = this._edit.bind(this);
    this._delete = this._delete.bind(this);
    this._saveUser = this._saveUser.bind(this);
    this._dismissUser = this._dismissUser.bind(this);
    this._fakeEventBucket = this._fakeEventBucket.bind(this);
    this._makeRowForUser = this._makeRowForUser.bind(this);
  }

  _edit(id, e) {
    e.preventDefault();
    this.setState({ userIdBeingEdited: id });
  }

  _delete(id, e) {
    e.preventDefault();

    if (
      window.confirm(
        `Are you sure you want to delete "${this.props.users[id].organization}"? There is NOOOO going back.`
      )
    ) {
      UserActions.godDeleteUser(id);
      this.state.deletedUsers[id] = true;
      this.setState(this.state);
    }
  }

  _become(id, e) {
    e.preventDefault();
    UserActions.setGodUser(id);
  }

  _saveUser(user) {
    let id = this.state.userIdBeingEdited;

    if (id === NEW_USER) {
      UserActions.godCreateUser(user);
    } else {
      UserActions.godEditUser(id, user);
    }

    this._dismissUser();
  }

  _dismissUser() {
    this.setState({ userIdBeingEdited: null });
  }

  _fakeEventBucket({ name, timezone } = {}) {
    GodActions.createFakeEventBucket({
      user: this.state.userIdBeingEdited,
      name: name,
      timezone: timezone
    });
    this._dismissUser();
  }

  _makeRowForUser(user) {
    let isDeleted = this.state.deletedUsers[user.id],
      isCurrentUser = this.props.currentUser === user.id;

    return (
      <Tr
        style={isDeleted && { textDecoration: "line-through", color: "#ccc" }}
        key={user.id}
      >
        <Td column="Organization" value={user.organization}>
          <div>
            {isCurrentUser ? (
              "👤"
            ) : (
              <a
                href="#"
                style={{ textDecoration: "none", opacity: 0.25 }}
                onClick={this._become.bind(this, user.id)}
              >
                👤
              </a>
            )}
            &nbsp;
            {user.organization}&nbsp;
            <span style={{ fontSize: "0.75em", color: "#ccc" }}>{user.id}</span>
          </div>
        </Td>
        <Td column="Type">
          {user.type === "festival_organizer"
            ? "Festival"
            : user.type === "content_creator"
            ? "Content Creator"
            : user.type}
        </Td>
        <Td column="Status">{user.is_demo ? "Demo" : "Standard"}</Td>
        <Td column="Virtual Status">
          {user.virtual_festival_plan_status
            ? `${user.virtual_festival_plan} – ${user.virtual_festival_plan_status}`
            : ``}
        </Td>
        <Td column="Fee Percent">{`${user.fee_percent}%`}</Td>
        <Td column="Currency">{(user.currency || "UNK").toUpperCase()}</Td>
        <Td column="Actions">
          {
            <div>
              <a
                style={isDeleted && { color: "#ccc" }}
                href="#"
                onClick={this._edit.bind(this, user.id)}
              >
                Edit
              </a>
              {!isDeleted && !isCurrentUser && (
                <span>
                  &nbsp;
                  <a href="#" onClick={this._delete.bind(this, user.id)}>
                    Delete
                  </a>
                </span>
              )}
            </div>
          }
        </Td>
      </Tr>
    );
  }

  render() {
    let rows = Object.values(this.props.users).map(this._makeRowForUser);

    return (
      <div>
        {this.state.userIdBeingEdited ? (
          <UserEditorModal
            isNew={this.state.userIdBeingEdited === NEW_USER}
            user={this.props.users[this.state.userIdBeingEdited]}
            roles={this.props.roles}
            onSave={this._saveUser}
            onCancel={this._dismissUser}
            onFakeEventBucket={this._fakeEventBucket}
          />
        ) : null}
        <Table
          className="bordered striped responsive-table"
          columns={[
            "Organization",
            "Type",
            "Currency",
            "Virtual Status",
            "Fee Percent",
            "Status",
            "Actions"
          ]}
          sortable
        >
          {rows}
        </Table>
        {!this.props.hideAddButton ? (
          <RaisedButton
            label="Add new organization"
            primary={true}
            style={{ marginTop: 10 }}
            onTouchTap={this._edit.bind(this, NEW_USER)}
          />
        ) : null}
      </div>
    );
  }
}

export default UserTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/user-table.jsx